module.exports = __webpack_public_path__ + "img/20190628160656606.7215343d.png";